import { frontendURL } from '../../../helper/URLHelper';
import CatalogIndex from './pages/CatalogIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'manager', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/catalog'),
    name: 'products',
    component: CatalogIndex,
    meta: commonMeta,
  },
];
